import { render, staticRenderFns } from "./OzBaseDialogBox.vue?vue&type=template&id=784c20fb&"
import script from "./OzBaseDialogBox.vue?vue&type=script&lang=ts&"
export * from "./OzBaseDialogBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports